import { useState } from 'react';

import { Currency } from '#src/__generated__/globalTypes.ts';

export const useCryptoDisplay = ({
  onlyShowFiatCurrency,
  defaultCurrency,
  controlledCryptoDisplay,
  onCryptoDisplayChange,
}: {
  onlyShowFiatCurrency: boolean;
  defaultCurrency: Nullable<Currency>;
  controlledCryptoDisplay: Nullable<boolean>;
  onCryptoDisplayChange: Nullable<(cryptoDisplay: boolean) => void>;
}): [boolean, () => void] => {
  const [cryptoDisplay, setCryptoDisplay] = useState(
    !onlyShowFiatCurrency && defaultCurrency === Currency.ETH
  );

  const toggleCryptoDisplay = () => {
    if (onCryptoDisplayChange) {
      onCryptoDisplayChange(!cryptoDisplay);
    } else {
      setCryptoDisplay(v => !v);
    }
  };

  return [controlledCryptoDisplay ?? cryptoDisplay, toggleCryptoDisplay];
};
